import { useEffect } from 'react';
import { scrollToBriefTarget } from './briefScroll.js';

/** Scroll to hash on load and hashchange (email deep links, shared URLs). */
export function useBriefHashScroll(ready) {
  useEffect(() => {
    if (!ready) return undefined;

    const run = () => scrollToBriefTarget(window.location.hash, { updateHash: false });
    run();

    window.addEventListener('hashchange', run);
    return () => window.removeEventListener('hashchange', run);
  }, [ready]);
}
